import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

import { Message } from "../models/message.model";

@Injectable()
export class MessageService {
    text: string = "";

    public message = new Subject<Message>();

    updateMessage(text: string): void {
        this.message.next({ curMessage : text });
    }

    getMessage(): Observable<any> {
        return this.message.asObservable();
    }
}